import * as constants from './constants';

const defaultState = {
    userChargeList: {},
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case constants.USER_CHARGE_LIST:
            return {...state, userChargeList: action.value}
        default:
            return state;
    }
}